import React from "react";
import ContentListGrid from "../components/ContentListGrid";
import PublicPageSettings from "../components/PublicPageSettings";
import { COLLECTIONS } from "../utils/cmsSchema";

export default function BlogsList() {
  return (
    <div>
      <PublicPageSettings
        collectionKey="blogs"
        publicPath="/blogs"
        defaultHeading="Blogs"
        defaultSubheading=""
      />
      <ContentListGrid
        schema={COLLECTIONS.blogs}
        title="Blogs"
        subtitle="Long-form posts shown on /blogs."
        newRoute="/cms/blogs/new"
        metaFor={(d) => d.author || ""}
      />
    </div>
  );
}
